import { render } from "./FilterDetailPanel.vue?vue&type=template&id=87c5362e&scoped=true"
import script from "./FilterDetailPanel.vue?vue&type=script&lang=js"
export * from "./FilterDetailPanel.vue?vue&type=script&lang=js"

import "./FilterDetailPanel.vue?vue&type=style&index=0&id=87c5362e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c5362e"]])

export default __exports__